import type { MixtureUsage } from '../../utils/mixturesMapper';
import { formatMixtureDecimal } from '../../utils/mixturesMapper';
import styles from './MixtureCard.module.css';

const concentrationFormatter = new Intl.NumberFormat('pt-BR', {
	minimumFractionDigits: 1,
	maximumFractionDigits: 1,
});

export const formatConcentration = (value: number) => concentrationFormatter.format(value);

export const MixtureUsageSummary = ({ usage }: { usage: MixtureUsage }) => (
	<p className={styles.usage}>
		<strong className={styles.usageStrong}>
			{formatMixtureDecimal(usage.massKg)} de {formatMixtureDecimal(usage.massLimitKg)} kg
		</strong>{' '}
		de adubo · concentração de{' '}
		<strong className={styles.usageStrong}>
			{formatConcentration(usage.concentration)} de {formatConcentration(usage.cemMax)} g/L
		</strong>
	</p>
);
